import { DeviceConnectionState, SensorValueChangePayload } from '../../../../../../data-access/gql-types/graphql';
import { useChannelsStateStore } from '../../../../store/channels-state';
import { ChannelSensorStateType } from '../../../../types';

export const useLavvaDeviceSensorUpdate = () => {
  const setChannelState = useChannelsStateStore((s) => s.setChannelState);

  const updateLavvaSensorState = ({ channelId, value }: SensorValueChangePayload) => {
    setChannelState(channelId, {
      deviceConnectionState: DeviceConnectionState.Connected,
      value,
    } as ChannelSensorStateType);
  };

  return {
    updateLavvaSensorState,
  };
};
